import type { EnqueueSnackbar, OptionsObject, VariantType } from 'notistack';
import { ToastProviderToastProps } from '../providers/ToastProvider';
import { ToastProps } from '../types/ToastProps';

/**
 * Pushes a toast to the snackbar provider using the enqueueSnackbar function
 */
export const pushToast = ({
  severity,
  title,
  subtitle,
  autoHideDuration,
  anchorOrigin,
  onToastClose,
  enqueueSnackbar,
}: ToastProviderToastProps & { enqueueSnackbar: EnqueueSnackbar }) => {
  // Options for enqueueSnackbar; we pass empty message because we render custom content
  type SnackbarExtraOptions = OptionsObject<VariantType> &
    Pick<ToastProviderToastProps, 'title' | 'onToastClose'> & {
      apSeverity: ToastProps['severity'];
      subtitle?: string;
    };

  const options: SnackbarExtraOptions = {
    autoHideDuration: autoHideDuration ?? 3000,
    anchorOrigin: anchorOrigin ?? { vertical: 'bottom', horizontal: 'left' },
    persist: autoHideDuration === null,
    variant: severity,
    title,
    subtitle,
    onToastClose,
    apSeverity: severity,
  };

  enqueueSnackbar('', options);
};
